import { render, staticRenderFns } from "./return-num.vue?vue&type=template&id=94059992&scoped=true"
import script from "./return-num.vue?vue&type=script&lang=js"
export * from "./return-num.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94059992",
  null
  
)

export default component.exports